module.exports = __webpack_public_path__ + "img/122.0556f45e.jpg";